import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgCaption02 = (props) => {
  return <LSRgCaption02Wrapper {...props} />;
};

export default LSRgCaption02;

const LSRgCaption02Wrapper = styled(LineSeedKrRg)`
  font-size: 12px;
  font-weight: 400;
  line-height: 14.4px;
  letter-spacing: -0.3px;

  color: #222222;
`;
